import { MRT_Row, MRT_RowData, MRT_TableOptions } from 'material-react-table';

type TableOptions<TData extends MRT_RowData> = Omit<
  MRT_TableOptions<TData>,
  'columns' | 'data'
>;

type Options<TData extends MRT_RowData> = Partial<{
  enableRowActions: boolean;
  enableRowSelection: boolean | ((a: MRT_Row<TData>) => boolean);
}>;

export const composeTableOptions = <TData extends MRT_RowData>(
  options?: Options<TData>,
): TableOptions<TData> => {
  const defaultOptions: TableOptions<TData> = {
    layoutMode: 'grid',
    enableColumnActions: false,
    enableMultiRowSelection: false,
    enablePagination: false,
    enableRowActions: false,
    enableRowSelection: false,
    enableSelectAll: false,
    enableBottomToolbar: false,
    positionActionsColumn: 'last',
    positionToolbarAlertBanner: 'none',

    // Top Toolbar - need the progress bar, nothing else
    enableTopToolbar: true,
    enableToolbarInternalActions: false,
    enableGlobalFilter: false,
    enableColumnFilters: false,
    enableDensityToggle: false,
    enableFullScreenToggle: false,
    enableHiding: false,

    muiTopToolbarProps: {
      sx: {
        // MUI Toolbar defaults to 56 px
        minHeight: '4px',
        height: '4px',
        p: 0,
      },
    },

    muiTableBodyRowProps: {
      hover: false,
    },

    displayColumnDefOptions: {
      'mrt-row-actions': {
        header: undefined,
        grow: false,
        size: 80,
      },
    },
  };

  const result: TableOptions<TData> = {
    ...defaultOptions,
  };

  if (options?.enableRowSelection) {
    result.enableMultiRowSelection = true;
    result.enableRowSelection = options.enableRowSelection;
    result.enableSelectAll = true;
    result.muiSelectAllCheckboxProps = ({ table }) => ({
      onChange: () => {
        const shouldSelectAll =
          !table.getIsAllRowsSelected() && !table.getIsSomeRowsSelected();
        table.toggleAllRowsSelected(shouldSelectAll);
      },
    });
  }

  if (options?.enableRowActions) {
    result.enableRowActions = true;
  }

  return result;
};
